/** 后端通用响应 app.schemas.response.Response */
export interface ApiResponse<T = unknown> {
  success: boolean;
  message?: string | null;
  data?: T;
}

/** 登录 Token 响应 app.schemas.token.Token */
export interface TokenResponse {
  access_token: string;
  token_type: string;
  super_user: boolean;
  user_id: number;
  user_name: string;
  avatar?: string | null;
  level: number;
  permissions?: Record<string, unknown>;
  wizard?: boolean | null;
}

export class ApiError extends Error {
  status: number;
  mfaRequired: boolean;

  constructor(message: string, status: number, mfaRequired = false) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.mfaRequired = mfaRequired;
  }
}
